import { Tooltip } from '@gisce/oficina-virtual-components'
import {
  Card, CardContent, CardActions, Typography, Box,
  Grid, Button,
} from '@mui/material';
import { Create } from '@mui/icons-material';
import TextFieldEdit from "../../../TextFieldEdit/TextFieldEdit";
import { useTranslation } from 'react-i18next';
import { ContractDisplayTypes, ContractModificationTypes } from '../../types/contracts';
import { useSettingsContext } from '@/components/Settings/hooks/useSettingsContext';
import useAuth from '@/components/Authentication/hooks/useAuth';
// import ContractElectronicNotification from './components/ElectronicNotificationAction';
import { useContracts } from '../../hooks/useContracts';
import TextFieldReadOnly from '@/components/TextFieldReadOnly/TextFieldReadOnly';

interface IContactDetailsPanelProps {
  type: ContractDisplayTypes;
  openDialog: (type: ContractModificationTypes) => void;
}

export const ContactDetailsPanel = ({
  type,
  openDialog
}: IContactDetailsPanelProps) => {
  const { t } = useTranslation();
  const Settings = useSettingsContext();
  const { tokenVals } = useAuth();
  const { 
    onUpdateNotificationPhone,
    onUpdateNotificationEmail,
    currentContract: contract
  } = useContracts(type);
  
  const tokenReadOnly = tokenVals?.readonly;

  return contract && <Card sx={{marginBottom: 3}}>
    <CardContent>
      <Box pb={2}>
        <Typography variant="h5">
          {t('common:text.contract_contact_data')}
        </Typography>
      </Box>
      <Grid container>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly
            label={t('common:text.contract_contact_data_name')}
          >
            {contract.notification_address?.name}
          </TextFieldReadOnly>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextFieldReadOnly
            label={t('common:text.contract_contact_data_address')}
          >
            {contract.notification_address.full_address}
          </TextFieldReadOnly>
        </Grid>
        <Grid item xs={12} md={6}>
          {!contract.notification_address.email &&
            <TextFieldEdit
              label={t('common:text.contract_contact_data_email')}
              onUpdated={onUpdateNotificationEmail}
            />
          }
          {contract.notification_address.email && 
            <TextFieldReadOnly label={t('common:text.contract_contact_data_send_type')}>
              {contract.invoice_online === 'email' && t('common:text.invoice_online_email')} 
              {contract.invoice_online === 'postal' && t('common:text.invoice_online_postal')}
              {contract.invoice_online === 'postal+email' && t('common:text.invoice_online_postal_and_email')}
              
              {Settings.features.modifyInvoiceOnline &&
                contract.state === 'activa' && 
                <Tooltip
                  title={!!tokenReadOnly &&
                    t("common:text.token_readonly_tooltip")
                  }
                  placement="right"
                  arrow
                  disableFocusListener={!!tokenReadOnly}
                  disableHoverListener={!!tokenReadOnly}
                  disableTouchListener={!!tokenReadOnly}
                  slotProps={{
                    popper: {
                      modifiers: [{
                        name: 'offset',
                        options: {offset: [0, -5]}
                      }]
                    }
                  }}
                >
                  <span style={{ 'width': '100%' }}>
                    <Button
                      variant={'text'}
                      color={'primary'}
                      disabled={!!tokenReadOnly}
                      title={t('common:text.invoice_online_dialog_title')}
                      onClick={() => openDialog("invoiceOnline")}
                    >
                      {t('common:text.contract_modification')}
                    </Button>
                  </span>
                </Tooltip>
              }
            </TextFieldReadOnly>
          }
        </Grid>
        <Grid item xs={12} md={6}>
          {!contract.notification_address.mobile &&
            <TextFieldEdit
              label={t('common:text.contract_contact_data_phone')}
              onUpdated={onUpdateNotificationPhone}
            />
          }
          {contract.notification_address.mobile &&
            <TextFieldReadOnly
              label={t('common:text.contract_contact_data_phone')}
            >
              {contract.notification_address.mobile}
            </TextFieldReadOnly>
          }
        </Grid>
      </Grid>
    </CardContent>
    <CardActions>
      <Box flexWrap="wrap" px={1} pb={1}>
        {Settings.features?.notificacionAddressChange &&
          contract.state === 'activa' && 
          <Tooltip
            title={tokenReadOnly &&
              t("common:text.token_readonly_tooltip")
            }
            placement="right"
            arrow
            disableFocusListener={!tokenReadOnly}
            disableHoverListener={!tokenReadOnly}
            disableTouchListener={!tokenReadOnly}
            slotProps={{
              popper: {
                modifiers: [{
                  name: 'offset',
                  options: {offset: [0, -5]}
                }]
              }
            }}
          >
            <span style={{ 'width': '100%' }}>
              <Button
                key={'modifyAddress'}
                variant={'contained'}
                color={'primary'}
                disabled={!!tokenReadOnly}
                title={t('common:text.contract_modification')}
                onClick={() => openDialog("address")}
                style={{marginRight: 12, marginTop: 8}}
              >
                {<Create style={{marginRight: 10}}/>}
                {t('common:text.contract_modification')}
              </Button>
            </span>
          </Tooltip>
        }
      </Box>
    </CardActions>
  </Card>
}